import { Injectable } from '@angular/core';
import { EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { DateTime } from 'luxon';
import { PlEntityCollectionService } from 'pl-core-services';
import { Event } from '../models';

@Injectable()
export class PlEventService extends PlEntityCollectionService<Event> {
  defaultDuration = 30;

  defaultStart = DateTime.now().toLocaleString(DateTime.TIME_24_SIMPLE);

  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
    super('Event', serviceElementsFactory);
  }

  dateWithTime(date: DateTime, time: string): DateTime {
    const [hour, minute] = time.split(':');
    if (hour == null || minute == null) return null;
    return date.startOf('day').set({
      hour: this.checkForPM(time),
      minute: parseInt(minute, 10),
    });
  }

  checkForPM(time: string) {
    const [hourStr, minuteStr] = time.split(':');
    let hour = parseInt(hourStr, 10);
    if (minuteStr.includes('PM') && hour < 12) {
      hour += 12;
    }
    if (minuteStr.includes('AM') && hour === 12) {
      hour -= 12;
    }
    return hour;
  }

  getDefaultEvent(
    startTime: string = this.defaultStart,
    duration: number = this.defaultDuration,
    date?: DateTime
  ): Event {
    const today: DateTime = DateTime.now();
    const startDateLocal = this.dateWithTime(date || today, startTime);
    const endDateLocal = startDateLocal.plus({ minutes: duration });
    return {
      start_date_local: startDateLocal,
      end_date_local: endDateLocal,
    };
  }
}
